// API Configuration
// export const API_BASE_URL = 'http://localhost:5001';
export const API_BASE_URL = 'https://car-backend-deploymnet.vercel.app';

// Environment Configuration
export const NODE_ENV = process.env.NODE_ENV || 'development';

// Admin Configuration
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || 'aryanarshad5413@gmail.com'; 
